import React, { useRef, useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicEmailInput
} from '../software-dynamic-version-5/mainSection-multiple-inputs-v-5';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import securityService from '../security/security.service';
import saleInvoiceService from '../sale-invoice/sale-invoice.service';
const SellerAdd = (props) => {
  console.log(props)
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent, DynamicTextInput: TextComponent, DynamicCheckBoxInput: CheckBoxComponent, DynamicHiddenInput: HiddenComponent, DynamicButtonInput: ButtonComponent, DynamicCellInput: PhoneComponent, DynamicEmailInput: EmailComponent } = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput, DynamicTextInput, DynamicCheckBoxInput, DynamicHiddenInput, DynamicButtonInput, DynamicCellInput, DynamicEmailInput };

  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key],
          };
        }
      });
      return updatedValues;
    });
  };

  const [inputProps, setInputProps] = useState({
    sellerNTNCNIC: { name: 'sellerNTNCNIC', value: props.sellerNTNCNIC || '', enabled: false },
    sellerBusinessName: { name: 'sellerBusinessName', value: props.sellerBusinessName || '' },
    SellerProvinceName: {
      name: { id: 'stateProvinceCode', value: 'SellerProvinceName' },
      caption: 'Select Province',
      value: {
        id: props.stateProvinceCode || '',
        value: props.SellerProvinceName || ''
      },
      dataSource: { type: 'Route', route: 'provinces' }
    },
    sellerAddress: { name: 'sellerAddress', value: props.sellerAddress || '' },
    SellerRemarks: { name: 'SellerRemarks', value: props.SellerRemarks || '' },
    sellerNTNCNICReferenceNo: { name: 'sellerNTNCNICReferenceNo', value: props.sellerNTNCNICReferenceNo || '' },
    sellerContactPerson: { name: 'sellerContactPerson', value: props.sellerContactPerson || '' },
    sellerContactNumber: { name: 'sellerContactNumber', value: props.sellerContactNumber || '' },
    sellerSTRN: { name: 'sellerSTRN', value: props.sellerSTRN || '' },
    sellerCNIC: { name: 'sellerCNIC', value: props.sellerCNIC || '' },
    SellerLogo: { name: 'SellerLogo', value: props.SellerLogo || '' },
    hsCodeValue:{
      name:{id:'DefaultHS_Code',value:'hsCodeValue'},
      caption: 'HSCode Description',
      value: {id: props?.DefaultHS_Code  ,value: ''},
      dataSource: {type:'Data',data:[]},
      isControlBlur:false

    },
    
  });


  
const getHSCodeSource = async (Inputfocus = false , CompanyID = securityService.getCompanyIDLoggedInUserId())=>{
  let response = await saleInvoiceService.getItemDescCode(CompanyID);
  if(response){
    console.log(response);
    let hsCodeDataSource = response.data.map((row)=> { return {id:row.hS_CODE ,value:`${row.hS_CODE} | ${row.description}`}});
    console.log(hsCodeDataSource);
    updateMainSecionsValue(
      {
        hsCodeValue:{
          dataSource: {type:'Data',data:hsCodeDataSource || []}
        }
      }
    )

    if(
      props.DefaultHS_Code
      ){
    document.getElementById('hsCodeValue').value = hsCodeDataSource.filter(e => e.id == props.DefaultHS_Code)[0].value || ''
    updateMainSecionsValue({
    hsCodeValue:{value: {
      id: props.DefaultHS_Code  ,
      value: hsCodeDataSource.filter(e => e.id == props.DefaultHS_Code)[0].value || ''}}
    })
  }
    
    if(Inputfocus == true ){
    setTimeout(() => {
      document.getElementById('hsCode').focus()
    }, 500);
  }
  }
}

useEffect(()=>{

  getHSCodeSource()
},[])



  // Image Upload States
  const [imagePreview, setImagePreview] = useState(securityService.getCompanyImage());
  const [uploadError, setUploadError] = useState('');
  const [fileInfo, setFileInfo] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [showImageTooltip, setShowImageTooltip] = useState(false); // NEW: Tooltip state
  const fileInputRef = useRef(null);

  // Validation Constants
  const MAX_FILE_SIZE = 100 * 1024; // 100KB
  const ALLOWED_TYPES = ['image/jpeg', 'image/jpg'];
  const ALLOWED_EXTENSIONS = ['jpg', 'jpeg'];

  const validateFile = (file) => {
    setUploadError('');
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const isValidType = ALLOWED_TYPES.includes(file.type) || ALLOWED_EXTENSIONS.includes(fileExtension);
    
    if (!isValidType) {
      setUploadError('Invalid format. Only JPG/JPEG allowed.');
      return false;
    }

    if (file.size > MAX_FILE_SIZE) {
      const sizeKB = (file.size / 1024).toFixed(1);
      setUploadError(`File too large (${sizeKB}KB). Max: 100KB.`);
      return false;
    }

    return true;
  };
useEffect(()=>{
  updateMainSecionsValue({ SellerLogo: { value:securityService.getCompanyImage() } });

  
},[])
  const processFile = (file) => {
    if (!validateFile(file)) return;

    setFileInfo({
      name: file.name,
      size: (file.size / 1024).toFixed(1) + ' KB'
    });

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      updateMainSecionsValue({ SellerLogo: { value: reader.result } });
    };
    reader.readAsDataURL(file);
  };

  const handleFileChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) processFile(file);
  };

  const handleRemoveImage = () => {
    setImagePreview('');
    setFileInfo(null);
    setUploadError('');
    updateMainSecionsValue({ SellerLogo: { value: '' } });
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) processFile(file);
  };

  const handleInputCreated = async (e, name) => {
    console.log(`Input ${name} created`);
  };

  const handleInputChange = async (value, name) => {
    console.log(`Input ${name} changed to ${value}`);
  };

  const inputsList = [
    { Input: TextComponent, Props: { ...inputProps.sellerNTNCNIC, setInputProps, onChange: handleInputChange }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.sellerBusinessName, setInputProps }, ColumnSize: 6 },
    {
      Input: DropdownComponent,
      Props: { ...inputProps.SellerProvinceName, setInputProps, onCreated: handleInputCreated },
      ColumnSize: 6
    },
    { Input: TextComponent, Props: { ...inputProps.sellerAddress, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.sellerContactPerson, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.sellerContactNumber, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.sellerSTRN, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.sellerCNIC, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.SellerRemarks, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.sellerNTNCNICReferenceNo, setInputProps }, ColumnSize: 6 },

    {Input: DropdownComponent,Props: {...inputProps.hsCodeValue,setInputProps ,onChange:handleInputChange},ColumnSize:6},
    { Input: HiddenComponent, Props: { ...inputProps.SellerLogo, setInputProps }, ColumnSize: 0 },
    
    // COMPACT IMAGE UPLOADER WITH HOVER TOOLTIP
    {
      Input: () => {
        return (
          <div className="col-12">
            <div className="form-group mb-0 mt-2">
              <small className="font-weight-bold text-muted d-block mb-1">
                <i className="fas fa-image text-success mr-1"></i>Company Logo
              </small>
              
              {/* Compact Upload Box */}
              <div 
                className={`border rounded p-2 bg-light ${isDragging ? 'border-success bg-white' : 'border-secondary'} ${uploadError ? 'border-danger' : ''}`}
                style={{ minHeight: imagePreview ? 'auto' : '70px', transition: 'all 0.2s' }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                {/* Error Message */}
                {uploadError && (
                  <div className="alert alert-danger py-1 px-2 small mb-2">
                    <i className="fas fa-exclamation-triangle mr-1"></i>
                    {uploadError}
                  </div>
                )}

                {!imagePreview ? (
                  // Upload State - Compact
                  <div className="text-center">
                    <i className="fas fa-cloud-upload-alt text-secondary" style={{ fontSize: '1.2rem' }}></i>
                    <div className="small text-muted mt-1">
                      Drop JPG here or <span className="text-primary" style={{cursor: 'pointer'}} onClick={() => fileInputRef.current?.click()}>browse</span>
                    </div>
                    <small className="text-muted" style={{fontSize: '0.7rem'}}>Max 100KB</small>
                  </div>
                ) : (
                  // Preview State with Hover Tooltip
                  <div className="d-flex align-items-center position-relative">
                    {/* Thumbnail with Hover Events */}
                    <div 
                      className="position-relative"
                      onMouseEnter={() => setShowImageTooltip(true)}
                      onMouseLeave={() => setShowImageTooltip(false)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={imagePreview}
                        alt="Logo"
                        className="rounded border"
                        style={{ height: '50px', width: '50px', objectFit: 'cover' }}
                      />
                      <small className="position-absolute badge badge-dark" style={{bottom: '-2px', right: '-2px', fontSize: '0.6rem', padding: '1px 3px'}}>
                        <i className="fas fa-search-plus"></i>
                      </small>

                      {/* BIG IMAGE TOOLTIP - Shows on Hover */}
                      {showImageTooltip && (
                        <div 
                          className="position-absolute p-2 bg-white border rounded shadow-lg"
                          style={{ 
                            left: '60px', 
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 9999,
                            width: '400px',
                            height: '400px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#fff'
                          }}
                        >
                          <img
                            src={imagePreview}
                            alt="Large Preview"
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain',
                              borderRadius: '4px'
                            }}
                          />
                          {/* Arrow pointing to thumbnail */}
                          <div 
                            style={{
                              position: 'absolute',
                              left: '-8px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              width: '0',
                              height: '0',
                              borderTop: '8px solid transparent',
                              borderBottom: '8px solid transparent',
                              borderRight: '8px solid #fff'
                            }}
                          />
                        </div>
                      )}
                    </div>

                    <div className="ml-2 flex-grow-1" style={{minWidth: 0}}>
                      <small className="text-muted d-block text-truncate" style={{fontSize: '0.75rem'}}>
                        {fileInfo?.name || 'logo.jpg'}
                      </small>
                      <small className="text-success" style={{fontSize: '0.7rem'}}>
                        <i className="fas fa-check-circle mr-1"></i>Ready
                      </small>
                    </div>
                    
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-danger p-0 ml-2"
                      onClick={handleRemoveImage}
                      style={{fontSize: '0.8rem'}}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                )}

                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".jpg,.jpeg,image/jpeg"
                  onChange={handleFileChange}
                  className="d-none"
                />
              </div>
            </div>
          </div>
        );
      },
      Props: {},
      ColumnSize: 6
    }
  ];

  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <StructuredGenerate mainProps={props} title={`Seller ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList} />
    </div>
  );
};

export default SellerAdd;